export default {
  title: 'Easy Air Screen',
  subtitle: 'タブレットをワイヤレスセカンドモニターに変換',
  description: 'タブレットをmacOS用の高品質ワイヤレスディスプレイに変換します。ワークスペースを拡張し、生産性を向上させます—ケーブルは不要です。',
  downloadMobile: 'モバイルアプリをダウンロード',
  purchasePromise: '買い切りです。サブスクリプションも広告もありません。',
  companionPromise: 'Mac用アプリは無料で、アカウント登録も不要です。',
  downloadMacOS: 'macOS用ダウンロード (Universal)',
  quickSetup: 'クイックセットアップ',
  setupSteps: [
    'タブレットにEasy Air Screenをインストール',
    'macOS用のデスクトップアプリをダウンロードしてインストール',
    '両方のデバイスを同じWi-Fiネットワークに接続',
    '起動して接続！'
  ],
  performanceTip: 'パフォーマンスのヒント',
  performanceDescription: '最小限の遅延で最高の体験を得るには、両方のデバイスで5GHz Wi-Fi接続を使用してください。遅延に気づいた場合は、アプリ設定で解像度を下げてみてください。',
  faqTitle: 'よくある質問',
  faq: [
    {
      q: 'Sidecarとは何が違いますか？',
      a: 'Easy Air Screenは、2台のApple IDが異なっていても接続できます。AndroidタブレットもMacのワイヤレスサブディスプレイとして使えます。'
    },
    {
      q: 'Androidタブレットでも使えますか？',
      a: 'はい、AndroidタブレットをMacのワイヤレスサブディスプレイとして使えます。同じWi-Fiに接続すれば、画面の拡張と複製を選べます。'
    },
    {
      q: 'iPhoneもサブディスプレイになりますか？',
      a: 'はい、iPhoneもMacのワイヤレスサブディスプレイとして使えます。接続時に画面の拡張または複製を選択できます。'
    },
    {
      q: '画面は拡張ですか、それともミラーリングですか？',
      a: 'どちらにも対応しています。Macのデスクトップを別の画面へ拡張することも、現在の画面をそのまま複製することもできます。'
    },
    {
      q: 'インターネット接続は必要ですか？画面が外部に送られますか？',
      a: 'インターネット接続は必要ありません。同じWi-Fi内で直接接続し、画面が外部サーバーを経由したり保存されたりすることはありません。'
    },
    {
      q: 'サブスクリプションですか？',
      a: 'いいえ、デバイス用アプリは一度だけ購入します。サブスクリプションではなく広告もなく、Mac用の同伴アプリは無料でアカウント登録も不要です。'
    },
    {
      q: 'Windows PCでも使えますか？',
      a: 'いいえ、Easy Air ScreenはmacOS専用です。Windows PCには現在対応していません。'
    },
    {
      q: '画面が途切れたり遅かったりするときは？',
      a: '可能であれば両方のデバイスを5GHz Wi-Fiに接続してください。遅延を感じる場合は、アプリ設定で解像度を下げてみてください。'
    },
  ]
};
